// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-segmentation-rendering-tab {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.neuroglancer-segmentation-rendering-tab .neuroglancer-shader-code-widget {
  height: 6em;
}

.neuroglancer-segmentation-dropdown-skeleton-shader-header {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.neuroglancer-segmentation-layer-skeleton-shader-overlay
  .neuroglancer-shader-code-widget {
  width: 80vw;
  height: 80vh;
}

.neuroglancer-segment-list-entry {
  display: flex;
  flex-direction: row;
  width: min-content;
  min-width: 100%;
  background-color: black;
  align-items: start;
}

.neuroglancer-segment-list-entry.neuroglancer-segment-list-entry-double-line {
  display: inline-flex;
  min-width: initial;
  background-color: initial;
}

.neuroglancer-segment-list-entry[data-selected="true"],
.neuroglancer-selection-details-segment[data-selected="true"] {
  background-color: #222;
}

.neuroglancer-segment-list-entry-copy-container {
  display: flex;
  flex-direction: column;
}

.neuroglancer-segment-list-entry-id-container {
  order: 1;
  align-self: center;
}

.neuroglancer-segment-list-entry-id,
.neuroglancer-selection-details-segment-id {
  display: block;
  font-family: monospace;
  font-size: medium;
  flex-shrink: 0;
  text-align: right;
  color: black;
  background-color: white;
  user-select: text;
  width: var(--neuroglancer-segment-list-width);
}

.neuroglancer-segment-list .neuroglancer-segment-list-entry-sticky {
  position: sticky;
  left: 0;
}

.neuroglancer-segment-list-entry-sticky {
  white-space: nowrap;
  flex-direction: row;
  align-items: start;
  background-color: inherit;
  display: flex;
}

.neuroglancer-segment-list-entry.neuroglancer-segment-list-header
  .neuroglancer-segment-list-entry-star,
.neuroglancer-segment-list-entry.neuroglancer-segment-list-header:hover
  .neuroglancer-segment-list-entry-copy {
  visibility: hidden;
}

.neuroglancer-segment-list-entry-extra-property {
  padding-left: 8px;
  flex-shrink: 0;
  text-align: right;
  user-select: text;
}

.neuroglancer-selection-details-segment-description,
.neuroglancer-selection-details-segment-property {
  font-family: sans-serif;
  font-size: small;
}

.neuroglancer-selection-details-segment-property {
  display: flex;
  flex-direction: row;
}

.neuroglancer-selection-details-segment-property-name {
  user-select: text;
  font-style: italic;
}

.neuroglancer-selection-details-segment-property-value {
  text-align: right;
  flex: 1;
}

.neuroglancer-segmentation-toolbox {
  display: inline-block;
}

.neuroglancer-segmentation-toolbox
  .neuroglancer-tool-button
  + .neuroglancer-tool-button {
  margin-left: 1em;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/layer/segmentation/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;AAClB","sourcesContent":["/**\n * @license\n * Copyright 2016 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-segmentation-rendering-tab {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.neuroglancer-segmentation-rendering-tab .neuroglancer-shader-code-widget {\n  height: 6em;\n}\n\n.neuroglancer-segmentation-dropdown-skeleton-shader-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.neuroglancer-segmentation-layer-skeleton-shader-overlay\n  .neuroglancer-shader-code-widget {\n  width: 80vw;\n  height: 80vh;\n}\n\n.neuroglancer-segment-list-entry {\n  display: flex;\n  flex-direction: row;\n  width: min-content;\n  min-width: 100%;\n  background-color: black;\n  align-items: start;\n}\n\n.neuroglancer-segment-list-entry.neuroglancer-segment-list-entry-double-line {\n  display: inline-flex;\n  min-width: initial;\n  background-color: initial;\n}\n\n.neuroglancer-segment-list-entry[data-selected=\"true\"],\n.neuroglancer-selection-details-segment[data-selected=\"true\"] {\n  background-color: #222;\n}\n\n.neuroglancer-segment-list-entry-copy-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.neuroglancer-segment-list-entry-id-container {\n  order: 1;\n  align-self: center;\n}\n\n.neuroglancer-segment-list-entry-id,\n.neuroglancer-selection-details-segment-id {\n  display: block;\n  font-family: monospace;\n  font-size: medium;\n  flex-shrink: 0;\n  text-align: right;\n  color: black;\n  background-color: white;\n  user-select: text;\n  width: var(--neuroglancer-segment-list-width);\n}\n\n.neuroglancer-segment-list .neuroglancer-segment-list-entry-sticky {\n  position: sticky;\n  left: 0;\n}\n\n.neuroglancer-segment-list-entry-sticky {\n  white-space: nowrap;\n  flex-direction: row;\n  align-items: start;\n  background-color: inherit;\n  display: flex;\n}\n\n.neuroglancer-segment-list-entry.neuroglancer-segment-list-header\n  .neuroglancer-segment-list-entry-star,\n.neuroglancer-segment-list-entry.neuroglancer-segment-list-header:hover\n  .neuroglancer-segment-list-entry-copy {\n  visibility: hidden;\n}\n\n.neuroglancer-segment-list-entry-extra-property {\n  padding-left: 8px;\n  flex-shrink: 0;\n  text-align: right;\n  user-select: text;\n}\n\n.neuroglancer-selection-details-segment-description,\n.neuroglancer-selection-details-segment-property {\n  font-family: sans-serif;\n  font-size: small;\n}\n\n.neuroglancer-selection-details-segment-property {\n  display: flex;\n  flex-direction: row;\n}\n\n.neuroglancer-selection-details-segment-property-name {\n  user-select: text;\n  font-style: italic;\n}\n\n.neuroglancer-selection-details-segment-property-value {\n  text-align: right;\n  flex: 1;\n}\n\n.neuroglancer-segmentation-toolbox {\n  display: inline-block;\n}\n\n.neuroglancer-segmentation-toolbox\n  .neuroglancer-tool-button\n  + .neuroglancer-tool-button {\n  margin-left: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
